import {Fragment} from 'react';
import {getValidChildren} from '../../../../common/shared/utils/getValidChildren';
import {Divider} from '../../../../design-system/atoms/Divider/Divider';
import {theme} from '../../../../theme';
import {CommonGroupProps} from '../../type';

function TodaySeries({children}: CommonGroupProps) {
  const validChildren = getValidChildren(children);

  return (
    <>
      {validChildren.map((validChild, idx) => {
        return (
          <Fragment key={idx}>
            {validChild}
            {idx !== validChildren.length - 1 && (
              <Divider
                color={theme.colors['theme-transparent-20']}
                className="mx-15pxr mt-24pxr"
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
}

export default TodaySeries;
